// @flow
import * as React from 'react';
import styled from 'styled-components';
import LocationInputContainer from 'containers/LocationInputContainer';
import Field from './Field';

const StyledLocationInputContainer = styled(LocationInputContainer)`
  height: 45px;
`;

const LocationField = ({
  name,
  label,
  description,
  disabled,
  includeCity,
  includeFull,
  showClearButton,
  placeholder,
  onChange,
  onBlur,
  customErrorMatch,
  customError,
  success,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  disabled?: boolean,
  includeCity?: boolean,
  includeFull?: boolean,
  showClearButton?: boolean,
  placeholder?: string,
  onChange?: Function,
  onBlur?: Function,
  'data-qa-id'?: string,
  customErrorMatch?: APIErrors => Object,
  customError?: ?string,
  success?: boolean
}) => (
  <Field
    customErrorMatch={customErrorMatch}
    name={name}
    customError={customError}
    success={success}
    label={label}
    description={description}
    renderInput={({ value, id, qaId, hasError, hasSuccess, updateValue }) => {
      let locationText;
      if (value && typeof value === 'object') {
        if (value.text) {
          locationText = value.text;
        }

        // @TODO: possible to use just `full` or `text` on the client?
        if (value.full && includeFull) {
          locationText = value.full;
        }
      }

      return (
        <StyledLocationInputContainer
          id={id}
          name={name}
          locationText={locationText}
          data-qa-id={props['data-qa-id'] || qaId}
          onChange={location => {
            updateValue(location);
            if (onChange) {
              onChange(location);
            }
          }}
          hasError={hasError}
          hasSuccess={hasSuccess}
          onBlur={onBlur}
          disabled={disabled}
          showClearButton={showClearButton}
          includeCity={includeCity}
          includeFull={includeFull}
          placeholder={placeholder}
        />
      );
    }}
  />
);

export default LocationField;
